import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var quizMarksListRes;
export const quizMarksListTodo = createAsyncThunk('quizMarksList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_quiz_marks_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "status": data.status,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return quizMarksListRes = res.data
    } catch (error) {
        return quizMarksListRes = error.response.data
    }
})


const quizMarksListSlice = createSlice({
    name: 'quizMarksList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(quizMarksListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('quizMarksList', state.data)
            }
        });
        builder.addCase(quizMarksListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default quizMarksListSlice.reducer; 